"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAddToBasketLoyaltyResponse = exports.isAddToBasketErrorResponse = exports.Name = exports.AddToBasketFailedEvent = void 0;
var _failedEventData = require("@ori-events/failed-event-data");
const Name = exports.Name = 'add-to-basket-failed';
const AddToBasketFailedEvent = exports.AddToBasketFailedEvent = Name;
const isAddToBasketErrorResponse = response => (0, _failedEventData.isErrorResponse)(response);
exports.isAddToBasketErrorResponse = isAddToBasketErrorResponse;
const isAddToBasketLoyaltyResponse = response => Boolean(response.loyaltyPoints);
exports.isAddToBasketLoyaltyResponse = isAddToBasketLoyaltyResponse;
//# sourceMappingURL=index.js.map